import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  announcements: [],
  isCalledAnnouncements: false,
};

const announcementsSlice = createSlice({
  name: "announcements",
  initialState,
  reducers: {
    setAnnouncements(state, action) {
      state.announcements = action.payload || [];
    },
    clearAnnouncements(state) {
      state.announcements = [];
    },
    setCalledAnnouncements(state, action) {
      state.isCalledAnnouncements = action.payload || false;
    }
  },
});

export const { setAnnouncements, clearAnnouncements, setCalledAnnouncements } =
  announcementsSlice.actions;

export default announcementsSlice.reducer;